import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

import { CanDeactivateComponent } from "../../common/classes/can-deactivate.component";




@Injectable()
export class CanDeactivateGuardService  {

    canDeactivate(component: CanDeactivateComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): boolean | Observable<boolean> {
        return component.canDeactivate ? component.canDeactivate() : true;        
    }

    constructor() {
        
    }

}